import React from 'react';
import { Button, Dropdown } from 'antd';
import { CompressOutlined, ExpandOutlined } from '@ant-design/icons';
import { useTheme } from '../contexts/ThemeContext';
import { useTranslation } from 'react-i18next';

const ThemeSwitcher = ({ buttonClassName = '' }) => {
  const { isCompact, setIsCompact } = useTheme();
  const { t } = useTranslation();

  const handleThemeChange = ({ key }) => {
    setIsCompact(key === 'compact');
  };

  const menuItems = [
    {
      key: 'default',
      label: t('common.defaultTheme', 'Default'),
      icon: <ExpandOutlined />,
    },
    {
      key: 'compact',
      label: t('common.compactTheme', 'Compact'),
      icon: <CompressOutlined />,
    },
  ];

  const selectedKey = isCompact ? 'compact' : 'default';

  return (
    <Dropdown
      menu={{
        items: menuItems,
        onClick: handleThemeChange,
        selectedKeys: [selectedKey],
      }}
      placement="bottomRight"
      getPopupContainer={() => document.body}
      overlayStyle={{ zIndex: 1200 }}
    >
      <Button
        type="text"
        className={buttonClassName}
        icon={isCompact ? <CompressOutlined /> : <ExpandOutlined />}
        title={isCompact ? t('common.compactTheme', 'Compact') : t('common.defaultTheme', 'Default')}
      />
    </Dropdown>
  );
};

export default ThemeSwitcher;
